module.exports = __webpack_public_path__ + "img/ES-J-16.57119e28.svg";